export default from './AvatarWithBadge';



// WEBPACK FOOTER //
// ./src/sharedComponents/AvatarWithBadge/index.js